import { DelayType } from "../DelayTypes/types";
import { ProxyDelayDateType, ProxyDelayIntervalType, ProxyDelayPropertyType } from "./ProxyDelayTypes";

export default class ProxyDelayFabric {
  static getDelayType(type: DelayType, args?: any) {
    switch (type) {
      case DelayType.Date:
        return new ProxyDelayDateType({
          type: DelayType.Date,
          time: ''
        })
      case DelayType.Interval:
        return new ProxyDelayIntervalType({
          type: DelayType.Interval,
          offset: 0,
          limit: null
        })
      case DelayType.Property:
        return new ProxyDelayPropertyType({
          type: DelayType.Property,
          offset: 0,
          property_index: null,
          limit: null
        }, args)
    }

  }
}
